import { defaultFilterableOptions } from '../../core/default-filterable-options';
import { loadStates } from '@codametrix/ui-common';
import { AmplifyCore } from '@codametrix/ui-common';
import { formErrors } from '../../stubs/form-errors';
import { groups } from '../../stubs/groups';
const { paginationUtils } = AmplifyCore;
const { LOAD_STATES } = loadStates;
export const nameSortableOption = {
    sortField: 'name',
    sortDirection: 'ASC'
};
const sortablePageable = {
    pageableDefinition: {
        ...paginationUtils.emptyPageable
    },
    sortableOptions: [
        nameSortableOption
    ],
    filterableOptions: defaultFilterableOptions
};
const columnDefs = [
    {
        key: 'name',
        displayName: 'Name'
    },
    {
        key: 'type',
        displayName: 'Type'
    }
];
export const group = {
    groupsList: {
        loadState: LOAD_STATES.done,
        columnDefs,
        label: 'Group',
        itemName: 'Groups',
        sortablePageable
    },
    groupsFormErrors: formErrors.noErrors,
    items: [],
    selectedOrg: {
        id: -1
    },
    selectedGroup: {
        ...groups.defaultGroup
    },
    eligibleGroupMembers: []
};
